import React, { useCallback, useMemo, useState } from "react";
import CustomTable, { Column } from "../../../components/CustomTable";
import {
  ArrowPathIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
} from "@heroicons/react/24/outline";
// import { useNavigate } from "react-router-dom";
import { useReportTimesheetContext } from "../../../context/ReportTimsheetContex";
import { timesheetListResponse } from "../../../model/timesheet";
import moment from "moment";
import { useLoading } from "../../../context/LoadingContext";
import ReusableSearchInput from "../../../components/ReusableSearchInput";
import { FcSearch } from "react-icons/fc";
import { toast } from "react-toastify";
import {
  removeCookieData,
  setCookieData,
  getUserIdTokenForIonTime,
} from "../../../helper/api";
import MyTimesheetReport from "./myTimesheetReport";
import { ReportStatusEnum } from "../../../helper/constant";
import StaticModal from "../../../components/staticModel";
import useTimeSheetApi from "../../../api/timesheet";

export interface Data {
  id: number;
  projectName: string;
  timesheetPeriod: string;
  tsApprover: string;
  status: string;
}

const TimesheetsReportPage: React.FC = () => {
  // const navigate = useNavigate();
  const { isLoading } = useLoading();
  const {
    getReportTimesheetStatusList,
    timesheetReportList,
    setReportTimesheetList,
  } = useReportTimesheetContext();
  const { approveRejectReport } = useTimeSheetApi();
  const getUserId = getUserIdTokenForIonTime();

  const [statusValueData, setStateValueData] = React.useState<string>("");
  const [userName, setUserName] = React.useState<string>("");
  const [userID, setUserID] = React.useState<number | null>();
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pagePercount] = React.useState(10);
  const [showModal, setShowModal] = React.useState(false);

  // Bulk approve state
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [approvalProgress, setApprovalProgress] = useState({
    current: 0,
    total: 0,
  });
  const [isApproving, setIsApproving] = useState(false);
  // Only true once "Get Timesheets" is clicked while Status = Waiting for approval
  const [bulkApproveEnabled, setBulkApproveEnabled] = useState(false);

  const columns: Column<timesheetListResponse>[] = [
    { header: "Project Name", key: "projects", enableLink: false, path: "" },
    {
      header: "Timesheet Period",
      key: "start_date",
      enableLink: true,
      path: "/mytimesheetreport",
    },
    { header: "TS Approver", key: "approvers", enableLink: false, path: "" },
    { header: "Status", key: "status", enableLink: false, path: "" },
  ];

  const getCall = useCallback(
    async (
      userIDs: number | null,
      statusVal: number | null,
      pageNo?: number | null,
    ) => {
      if (userIDs) {
        const payload = {
          user_id: userIDs,
          status: statusVal ? [statusVal] : [1, 2, 3, 4, 5, 6, 7],
          page: pageNo ?? currentPage,
          page_per_count: pagePercount,
        };
        await getReportTimesheetStatusList(payload);
      }
    },
    [currentPage, pagePercount, getReportTimesheetStatusList],
  );
  React.useEffect(() => {
    removeCookieData("timesheetsReport");
    refreshTable();
  }, []);

  const mytimesheetList = useMemo(() => {
    return timesheetReportList?.data.map((item) => ({
      ...item,
      original_start_date: item.start_date,
      start_date:
        moment(item.start_date).format("D MMM YYYY") +
        " - " +
        moment(item.end_date).format("D MMM YYYY"),
      approvers: item.approvers.join(", "),
      projects: item.projects.join(", "),
    }));
  }, [timesheetReportList]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // const handleNavigation = (path: string | undefined, states: number) => {
  //   navigate(path ?? "", { state: { id: states } }); // Navigate to the specified path with state

  // };
  const handleNavigation = (
    path: string | undefined,
    states: number | string | null,
    memberID?: number | null,
  ) => {
    if (!userID) {
      toast.error("Employee name is required");
    }
    if (userID) {
      setCookieData(
        "timesheetsReport",
        JSON.stringify({
          id: states,
          memberID: memberID,
          role: "admin",
          employeeNameData: userName,
          // employeeIDData: filterdata[0].employee_id,
        }),
      );

      // const url = new URL(process.env.REACT_APP_BASE_URL ? window.location.origin + process.env.REACT_APP_BASE_URL + path : window.location.origin + path);

      // url.searchParams.set("id", states ? String(states) : "");
      // url.searchParams.set("memberID", String(memberID));
      // console.log(window.location.origin + path, 'window.location.origin + path')
      // Open the URL in a new tab
      // window.open(url.toString(), "_blank");
      // navigate(path ?? "", { state: { id: states, memberID: memberID } }); // Navigate to the specified path with state
      setShowModal(true);
    }
  };

  const refreshTable = () => {
    setReportTimesheetList(null);
    setStateValueData("");
    setUserName("");
    setUserID(null);
    setBulkApproveEnabled(false);
    setSelectedRows([]);
  };

  const totalPages = Math.ceil(
    Number(timesheetReportList?.record_total_count) / pagePercount,
  );

  const startRecord = (currentPage - 1) * pagePercount + 1;
  const endRecord = Math.min(
    startRecord + pagePercount - 1,
    Number(timesheetReportList?.record_total_count),
  );

  const handlePrePage = () => {
    if (currentPage > 1) {
      getCall(userID ?? null, Number(statusValueData), currentPage - 1);
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      getCall(userID ?? null, Number(statusValueData), currentPage + 1);
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  // Bulk approve helpers
  const handleSelectionChange = (ids: string[]) => {
    setSelectedRows(ids);
  };

  const getDatesBetween = (startDate: string, endDate: string) => {
    const dates: number[] = [];
    const currDate = moment(startDate);
    const lastDate = moment(endDate);
    while (currDate.diff(lastDate) <= 0) {
      dates.push(currDate.date());
      currDate.add(1, "days");
    }
    return dates;
  };

  const handleBulkApprove = async () => {
    setIsApproving(true);
    setApprovalProgress({ current: 0, total: selectedRows.length });

    for (let i = 0; i < selectedRows.length; i++) {
      const periodKey = selectedRows[i];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const reportData = mytimesheetList?.find(
        (r) => r.start_date === periodKey,
      ) as any;

      if (reportData) {
        const days = getDatesBetween(
          reportData.original_start_date,
          reportData.end_date,
        );
        const payload = {
          status: ReportStatusEnum.Approved,
          user_id: Number(getUserId),
          report_id: reportData.reports_id,
          remarks: "Approved",
          dates: days,
        };

        try {
          await approveRejectReport(payload);
        } catch (error) {
          console.error("Error approving report", reportData.reports_id, error);
        }
      }
      setApprovalProgress((prev) => ({ ...prev, current: i + 1 }));
    }

    setIsApproving(false);
    setIsApproveModalOpen(false);
    getCall(userID ?? null, Number(statusValueData), 1);
    setSelectedRows([]);
  };

  // const missing_timesheet = "/mytimesheetreport", timesheetReportList.

  return (
    <>
      <CustomTable
        idKeyName="start_date"
        showFilter={true}
        columns={columns}
        data={mytimesheetList ?? []}
        keyID2="member-id"
        handleNavigation={handleNavigation}
        showCheckbox={bulkApproveEnabled}
        selectedIds={selectedRows}
        onSelectionChange={handleSelectionChange}
      >
        <div>
          {timesheetReportList?.options && userID && (
            <button
              onClick={() => {
                handleNavigation(
                  "/mytimesheetreport",
                  timesheetReportList?.missing_timesheet &&
                    timesheetReportList?.missing_timesheet.length > 0
                    ? moment(
                        timesheetReportList?.missing_timesheet[0].start_date,
                      ).format("D MMM YYYY") +
                        " - " +
                        moment(
                          timesheetReportList?.missing_timesheet[0].end_date,
                        ).format("D MMM YYYY")
                    : "",
                  userID,
                );
                // handleNavigation("/mytimesheetreport", null, userID);
              }}
              className="flex items-center px-4 py-2 text-sm mb-3 bg-gray-900 text-white dark:text-gray-400 rounded-lg focus:outline-none hover:bg-gray-600"
            >
              Add TimeSheet
            </button>
          )}
          <div className="max-w-7xl gap-x-6 gap-y-4 grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 ">
            <div>
              <label
                htmlFor="status"
                className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400"
              >
                Employee Name
              </label>
              <div className="mt-2">
                <ReusableSearchInput
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  setOptionsData={(item) => {
                    setUserID(item?.iontime_id ?? null);
                    setUserName(item?.ldap_uid ?? "");
                  }}
                />
              </div>
            </div>
            {timesheetReportList?.options && (
              <div>
                <label
                  htmlFor="status"
                  className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400"
                >
                  Status
                </label>
                <div className="mt-2">
                  <select
                    id="status"
                    value={statusValueData}
                    onChange={(e) => {
                      setStateValueData(e.target.value);
                    }}
                    className="shadow-sm bg-white border border-gray-300 dark:text-gray-400 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                  >
                    <option value="">All</option>
                    {timesheetReportList?.options.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.display}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
            <div className="flex space-x-4">
              <button
                onClick={() => {
                  setBulkApproveEnabled(
                    statusValueData ===
                      String(ReportStatusEnum.Waitingforapproval) ||
                      statusValueData ===
                        String(ReportStatusEnum.PartiallyApproved),
                  );
                  setSelectedRows([]);
                  getCall(
                    userID ?? null,
                    statusValueData ? Number(statusValueData) : null,
                    1,
                  );
                }}
                className="flex  items-center px-4 py-2 mt-9 text-sm bg-blue-600 hover:bg-blue-800 text-white rounded-lg focus:outline-none"
              >
                <FcSearch className="h-5 w-5 text-white  mr-2" /> Get Timesheets
              </button>
              <button
                onClick={() => refreshTable()}
                className="flex  items-center px-4 py-2 mt-9 text-sm bg-red-700 hover:bg-red-800 text-white rounded-lg focus:outline-none "
              >
                <ArrowPathIcon className="h-5 w-5 text-white mr-2" /> Reset
              </button>
            </div>
          </div>

          {bulkApproveEnabled && selectedRows.length > 0 && (
            <div className="flex justify-end mt-2 mb-2">
              <button
                onClick={() => {
                  setApprovalProgress({
                    current: 0,
                    total: selectedRows.length,
                  });
                  setIsApproveModalOpen(true);
                }}
                className="flex items-center px-4 py-2 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded-lg focus:outline-none"
              >
                Approve Selected ({selectedRows.length})
              </button>
            </div>
          )}

          <div className="flex  items-center justify-between mt-5">
            <span className="text-sm text-gray-700 dark:text-gray-400">
              Showing{" "}
              <span className="font-semibold text-gray-900 dark:text-white">
                {Number(timesheetReportList?.record_total_count) > 0
                  ? startRecord
                  : 0}
              </span>{" "}
              to{" "}
              <span className="font-semibold text-gray-900 dark:text-white">
                {!endRecord ? 0 : endRecord}
              </span>{" "}
              of{" "}
              <span className="font-semibold text-gray-900 dark:text-white">
                {timesheetReportList?.record_total_count ?? 0}
              </span>{" "}
              Records
            </span>
            {Number(timesheetReportList?.record_total_count) > 10 && (
              <div className="inline-flex xs:mt-0">
                <button
                  disabled={currentPage === 1}
                  onClick={() => handlePrePage()}
                  className="flex items-center justify-center px-3 h-8 text-sm font-medium text-white bg-gray-800 rounded-s hover:bg-gray-900 dark:bg-gray-900 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                >
                  <ArrowLeftIcon className="h-4 w-4 text-white mr-2" />
                  Prev
                </button>
                <select
                  id="page"
                  value={currentPage}
                  onChange={(e) => {
                    setCurrentPage(Number(e.target.value));
                    getCall(Number(statusValueData), Number(e.target.value));
                  }}
                  className="shadow-sm bg-white border border-gray-800 dark:text-gray-400 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full px-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-700  dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                >
                  {Array.from({ length: totalPages }, (_, index) => (
                    <option key={index + 1} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
                <button
                  disabled={currentPage === totalPages}
                  onClick={() => handleNextPage()}
                  className="flex items-center justify-center px-3 h-8 text-sm font-medium text-white bg-gray-800 border-0 border-s border-gray-700 rounded-e hover:bg-gray-900 dark:bg-gray-900 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                >
                  Next
                  <ArrowRightIcon className="h-4 w-4 text-white ml-2" />
                </button>
              </div>
            )}
          </div>

          {showModal && (
            <div className="fixed inset-0 z-50 flex items-stretch justify-center bg-black/50">
              <div className="relative w-full h-full bg-white dark:bg-gray-800 overflow-auto">
                <div className="p-4">
                  <MyTimesheetReport
                    onClose={() => setShowModal(false)}
                    hideHomeButton
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </CustomTable>

      <StaticModal
        isOpen={isApproveModalOpen}
        onClose={() => !isApproving && setIsApproveModalOpen(false)}
        headerName="Approve Timesheets"
      >
        <div className="p-4">
          {!isApproving ? (
            <>
              <p className="mb-4 text-gray-700 dark:text-gray-300">
                Are you sure you want to approve {selectedRows.length} selected
                timesheets?
              </p>
              <div className="flex justify-end space-x-4">
                <button
                  onClick={() => setIsApproveModalOpen(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Cancel
                </button>
                <button
                  onClick={handleBulkApprove}
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Confirm
                </button>
              </div>
            </>
          ) : (
            <div className="text-center">
              <p className="mb-4 text-lg font-semibold text-gray-700 dark:text-gray-300">
                Approving...
              </p>
              <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700 mb-2">
                <div
                  className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
                  style={{
                    width: `${(approvalProgress.current / approvalProgress.total) * 100}%`,
                  }}
                ></div>
              </div>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {approvalProgress.current} / {approvalProgress.total} processed
              </p>
            </div>
          )}
        </div>
      </StaticModal>
    </>
  );
};

export default TimesheetsReportPage;
